import { render, staticRenderFns } from "./ocularOpticalTestingDetail.vue?vue&type=template&id=128c6612&"
import script from "./ocularOpticalTestingDetail.vue?vue&type=script&lang=js&"
export * from "./ocularOpticalTestingDetail.vue?vue&type=script&lang=js&"
import style0 from "./ocularOpticalTestingDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports